"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHA384 = void 0;
var tslib_1 = require("tslib");
var min_max_1 = require("@devexpress/utils/lib/class/min-max");
var sha512_1 = require("./sha512");
var SHA384 = (function (_super) {
    tslib_1.__extends(SHA384, _super);
    function SHA384() {
        return _super.call(this) || this;
    }
    SHA384.prototype.getDefaultCache = function () {
        return [
            new min_max_1.MinMaxNumber(3238371032, 3418070365),
            new min_max_1.MinMaxNumber(914150663, 1654270250),
            new min_max_1.MinMaxNumber(812702999, 2438529370),
            new min_max_1.MinMaxNumber(4144912697, 355462360),
            new min_max_1.MinMaxNumber(4290775857, 1731405415),
            new min_max_1.MinMaxNumber(1750603025, 2394180231),
            new min_max_1.MinMaxNumber(1694076839, 3675008525),
            new min_max_1.MinMaxNumber(3204075428, 1203062813)
        ];
    };
    SHA384.prototype.computeHash = function (source) {
        var words = _super.prototype.computeHash.call(this, source);
        words.length -= 16 / 4;
        return words;
    };
    return SHA384;
}(sha512_1.SHA512));
exports.SHA384 = SHA384;
